
import { inAppRedirect } from '~/utils/route-redirects';

export default {
  name: 'NotificationFollow',
  props: {
    notif: {
      required: true,
      type: Object,
    },
  },
  methods: {
    goToProfile(targetId) {
      inAppRedirect(`/profile/${targetId}`);
    },
  },
};
